<script setup lang="ts">
import { container } from 'tsyringe'
import { RouterView } from 'vue-router'
import { CORE_LOCALE, type LocaleService } from '@/core'
import SeoDashboard from '&/components/SeoDashboard.vue'

const localeService = container.resolve<LocaleService>(CORE_LOCALE)
const antdLocaleResource = localeService.currentAntdLocaleResource()

const env = import.meta.env

</script>

<template>
  <a-config-provider :locale="antdLocaleResource">
    <RouterView />
    <!-- SEO监控面板（仅开发环境显示） -->
    <!-- <SeoDashboard v-if="env.VITE_MODE === 'development'" /> -->
  </a-config-provider>
</template>

<style lang="stylus">
</style>
